import React, { useState, useEffect } from 'react';
import { Download, X } from 'lucide-react';
import { useLanguage } from '../hooks/useTranslation';

const DISMISSED_KEY = 'pwa-install-dismissed';

export const PwaInstallBanner: React.FC = () => {
  const { language } = useLanguage();
  const [prompt, setPrompt] = useState<any>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(DISMISSED_KEY)) return;

    const handler = (e: Event) => {
      e.preventDefault();
      setPrompt(e);
      setVisible(true);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!prompt) return;
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === 'accepted') {
      setVisible(false);
    }
  };

  const handleDismiss = () => {
    setVisible(false);
    localStorage.setItem(DISMISSED_KEY, '1');
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 z-50 animate-in slide-in-from-bottom-4">
      <div className="bg-slate-800/95 backdrop-blur-xl border border-white/20 rounded-2xl shadow-2xl p-4 flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center flex-shrink-0">
          <Download className="w-5 h-5 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-white font-semibold text-sm">
            {language === 'fr' ? 'Installer CEDOTRACE' : 'Install CEDOTRACE'}
          </p>
          <p className="text-white/60 text-xs mt-0.5">
            {language === 'fr'
              ? 'Accédez rapidement depuis votre écran d\'accueil'
              : 'Quick access from your home screen'}
          </p>
          <div className="flex gap-2 mt-3">
            <button
              onClick={handleInstall}
              className="flex-1 py-1.5 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-lg text-xs font-semibold hover:opacity-90 transition-all"
            >
              {language === 'fr' ? 'Installer' : 'Install'}
            </button>
            <button
              onClick={handleDismiss}
              className="py-1.5 px-3 bg-white/10 hover:bg-white/20 text-white/70 rounded-lg text-xs transition-all"
            >
              {language === 'fr' ? 'Plus tard' : 'Later'}
            </button>
          </div>
        </div>
        <button
          onClick={handleDismiss}
          className="text-white/40 hover:text-white/70 transition-all flex-shrink-0"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
